import { render } from "./safeHtml.vue?vue&type=template&id=c745491a&scoped=true"
import script from "./safeHtml.vue?vue&type=script&lang=js"
export * from "./safeHtml.vue?vue&type=script&lang=js"

import "./safeHtml.vue?vue&type=style&index=0&id=c745491a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c745491a"]])

export default __exports__